const headerAccordionClass = 'c-header-accordion';
const headerAccordionOpenClass = headerAccordionClass + '--open';

const headerAccordionJsClass = 'js-header-accordion';
const buttonJsClass = headerAccordionJsClass + '-button';
const contentJsClass = headerAccordionJsClass + '-content';

const headerAccordionElements = document.querySelectorAll('.' + headerAccordionJsClass);
const buttonElements = document.querySelectorAll('.' + buttonJsClass);
const contentElements = document.querySelectorAll('.' + contentJsClass) as NodeListOf<HTMLElement>;

if (buttonElements.length > 0 && contentElements.length > 0 && buttonElements.length === contentElements.length) {
    // We wait for the page to fully load
    window.addEventListener('load', () => {
        buttonElements.forEach((buttonElement: HTMLElement, index: number) => {
            // We add an event listener on the button
            buttonElement.addEventListener('click', () => toggle(index));

            // We create a unique id for the content
            const contentId = `header-accordion-content-${index}`;
            contentElements[index].id = contentId;

            // We add the aria-controls propery on the button
            buttonElement.setAttribute('aria-controls', contentId);

            // We close the accordion
            toggle(index);
        });
    });
}

function toggle (index: number): void {
    const headerAccordionElement = headerAccordionElements[index];
    const contentElement = contentElements[index];

    if (!headerAccordionElement || !contentElement) {
        return;
    }

    // We toggle the active class
    headerAccordionElement.classList.toggle(headerAccordionOpenClass);

    // If the accordion is closed
    if (contentElement.style.maxHeight === '0px') {
        // We update the content's inert property to allow focus
        contentElement.inert = false;

        // We update the content's max height to open it
        contentElement.style.maxHeight = contentElement.scrollHeight + 'px';

        // We update the aria-expanded property
        buttonElements[index].setAttribute('aria-expanded', 'true');
    } else {
        // We update the content's inert property to prevent focus
        contentElement.inert = true;

        // We update the content's max height to close it
        contentElement.style.maxHeight = '0px';

        // We update the aria-expanded property
        buttonElements[index].setAttribute('aria-expanded', 'false');
    }
}

// We call this when the window is resized to make sure that the accordion's height matches it's content
export function updateHeaderAccordions (): void {
    headerAccordionElements.forEach((headerAccordionElement: HTMLElement, index: number) => {
        // If the accordion is open
        if (headerAccordionElement.classList.contains(headerAccordionOpenClass)) {
            if (contentElements[index]) {
                // We update the content's max height
                contentElements[index].style.maxHeight = contentElements[index].scrollHeight + 'px';
            }
        }
    });
}